import { createContext, useContext, useEffect, useState } from "react";

const DateScopeContext = createContext(null);

export function DateScopeProvider({ children }) {
  const [dateScope, setDateScopeState] = useState(() => {
    if (typeof window === "undefined") return "today";
    return window.localStorage.getItem("shiftbridge_date_scope") || "today";
  });

  const setDateScope = (nextScope) => {
    setDateScopeState(nextScope);
    window.localStorage.setItem("shiftbridge_date_scope", nextScope);
  };

  useEffect(() => {
    window.localStorage.setItem("shiftbridge_date_scope", dateScope);
  }, [dateScope]);

  return (
    <DateScopeContext.Provider value={{ dateScope, setDateScope }}>
      {children}
    </DateScopeContext.Provider>
  );
}

export function useDateScope() {
  return useContext(DateScopeContext) || {
    dateScope: "today",
    setDateScope: () => {},
  };
}